var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-card",
    [
      _c(
        "el-form",
        {
          ref: "form",
          attrs: {
            size: "mini",
            model: _vm.config.baseData,
            "label-width": "250px",
            "label-position": "left",
            "label-suffix": ": "
          }
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "系统名称" } },
            [
              _c("el-input", {
                staticStyle: { width: "300px" },
                attrs: { size: "mini" },
                model: {
                  value: _vm.config.baseData.systemName,
                  callback: function($$v) {
                    _vm.$set(_vm.config.baseData, "systemName", $$v)
                  },
                  expression: "config.baseData.systemName"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "等级自然晋级生效时间" } },
            [
              _c(
                "el-radio-group",
                {
                  model: {
                    value: _vm.config.baseData.gradeValidType,
                    callback: function($$v) {
                      _vm.$set(_vm.config.baseData, "gradeValidType", $$v)
                    },
                    expression: "config.baseData.gradeValidType"
                  }
                },
                [
                  _c("el-radio", { attrs: { label: 0 } }, [_vm._v("当日")]),
                  _c("el-radio", { attrs: { label: 1 } }, [_vm._v("次日")])
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "提现时扣除提现手续费" } },
            [
              _c(
                "el-row",
                [
                  _c("el-input-number", {
                    attrs: { size: "mini", min: 0, max: 100 },
                    model: {
                      value: _vm.config.baseData.takeTax,
                      callback: function($$v) {
                        _vm.$set(_vm.config.baseData, "takeTax", $$v)
                      },
                      expression: "config.baseData.takeTax"
                    }
                  }),
                  _c("span", { staticStyle: { "margin-left": "10px" } }, [
                    _vm._v("%")
                  ])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }